import React from 'react';
import './ImpactQuote.css';
import ModalDownload from '../download/DownloadResume';
import SkillsCloud from './SkillsCloud';

export default function ImpactQuote () {
  const mobileVersion = () => {alert("I'm working on an Expo/React-Native version of this website in my spare time. Please check back soon.")};
  return (
    <div className="quote">
      <h2>Web.<span>Developer</span>
      <br/><i>Front-End Developer / Web Specialist</i></h2>
      <ModalDownload />
      <SkillsCloud />
    </div>
  );
}